import { Icon } from "./Icon.tsx";

/** Generic "X" dismiss icon — distinct from CloseProjectIcon.tsx (which closes
    the whole project, not a panel/dialog). */
export function CloseIcon() {
  return (
    <Icon>
      <path d="M6 6l12 12" />
      <path d="M18 6l-12 12" />
    </Icon>
  );
}
